<template>
  <section class="stock">
    <div class="container-bs">
      <h1
        v-if="_.get(data, 'title', '')"
        class="stock__title"
      >
        {{ _.get(data, 'title', '') }}
      </h1>
      <div class="stock__wrap">
        <div
          class="stock__form"
          :class="{'stock__form_w100': _.isEmpty(isHasLeftFirstBlock) && isHasLeftSecondBlock}"
        >
          <div
            v-if="dataLoaded"
            class="stock__form-fields"
          >
            <BaseSelect
              v-model="formData.appeal"
              :items="_.get(formMeta, 'appeal.items', [])"
              :label="_.get(formMeta, 'appeal.label', '')"
              :placeholder="_.get(formMeta, 'appeal.placeholder', '')"
              :required="_.get(formMeta, 'appeal.required', false)"
              :errorMsg="errorMessages.appeal"
              class="stock__form-input"
            />
            <BaseInput
              v-model="formData.last_name"
              :label="_.get(formMeta, 'last_name.label', '')"
              :required="_.get(formMeta, 'last_name.required', false)"
              :errorMsg="errorMessages.last_name"
              class="stock__form-input"
            />

            <BaseInput
              v-model="formData.first_name"
              :label="_.get(formMeta, 'first_name.label', '')"
              :required="_.get(formMeta, 'first_name.required', false)"
              :errorMsg="errorMessages.first_name"
              class="stock__form-input"
            />

            <BaseInput
              v-model="formData.middle_name"
              :label="_.get(formMeta, 'middle_name.label', '')"
              :required="_.get(formMeta, 'middle_name.required', false)"
              :errorMsg="errorMessages.middle_name"
              class="stock__form-input"
            />

            <BaseInput
              v-model="formData.phone"
              :label="_.get(formMeta, 'phone.label', '')"
              :required="_.get(formMeta, 'phone.required', false)"
              :errorMsg="errorMessages.phone"
              type="tel"
              class="stock__form-input"
            />

            <BaseInput
              v-model="formData.email"
              :label="_.get(formMeta, 'email.label', '')"
              :required="_.get(formMeta, 'email.required', false)"
              :errorMsg="errorMessages.email"
              type="email"
              class="stock__form-input"
            />

            <BaseSelect
              v-model="formData.city_id"
              :items="_.get(formMeta, 'city_id.items', [])"
              :label="_.get(formMeta, 'city_id.label', '')"
              :placeholder="_.get(formMeta, 'city_id.placeholder', '')"
              :required="_.get(formMeta, 'city_id.required', false)"
              :disable="!!_.get($route.query, 'dealerAddress', '') || !!_.get($route.query, 'dealerName', '')"
              :errorMsg="errorMessages.city_id"
              class="stock__form-input"
              @input="getCity"
            />

            <BaseSelect
              v-model="formData.dealer_id"
              :items="_.get(formMeta, 'dealer_id.items', [])"
              :label="_.get(formMeta, 'dealer_id.label', '')"
              :placeholder="_.get(formMeta, 'dealer_id.placeholder', '')"
              :required="_.get(formMeta, 'dealer_id.required', false)"
              :disable="_.get($route, 'query.dealerName', '') ? true : false"
              :errorMsg="errorMessages.dealer_id"
              class="stock__form-input"
              @input="getDealer"
            />

            <BaseInput
              v-model="formData.comment"
              :label="_.get(formMeta, 'comment.label', '')"
              :required="_.get(formMeta, 'comment.required', false)"
              :errorMsg="errorMessages.comment"
              type="textarea"
              class="stock__form-input stock__form-input_area"
            />

            <BaseRadio
              v-if="!_.get(formMeta, 'contact_method.hidden', '')"
              v-model="formData.contact_method"
              :items="_.get(formMeta, 'contact_method.items', [])"
              :label="_.get(formMeta, 'contact_method.label', '')"
              :required="_.get(formMeta, 'contact_method.required', false)"
              :errorMsg="errorMessages.contact_method"
              class="stock__form-input stock__form-input_radio"
            />

            <div class="stock__form-solution">
              <div class="stock__form-solution-title">
                {{ _.get(solution, 'title', '') }}
              </div>
              <div class="stock__form-solution-description">
                {{ _.get(solution, 'description', '') }}
              </div>
              <div class="stock__form-solution-fields">
                <BaseCheckbox
                  v-model="formData.is_finance_solution"
                  class="stock__form-solution-checkbox"
                  :errorMsg="errorMessages.is_finance_solution"
                  typeNumber
                >
                  {{ _.get(solution, 'form.is_finance_solution.label', '') }}
                </BaseCheckbox>
                <BaseCheckbox
                  v-model="formData.is_trade_in"
                  class="stock__form-solution-checkbox"
                  :errorMsg="errorMessages.is_trade_in"
                  typeNumber
                >
                  {{ _.get(solution, 'form.is_trade_in.label', '') }}
                </BaseCheckbox>
              </div>
            </div>

            <div v-if="_.get(data, 'hintText', '')" class="service-request-page__editor-wrapper service-request-page__editor-wrapper_stock">
              <div class="stock__hint">
                <p class="service-request-page__editor" v-html="_.get(data, 'hintText', '')" />
                <div
                  v-show="isHintToggle"
                  class="stock__hint-toggle"
                  @click="hintToggle"
                >
                  &darr;
                </div>
              </div>
            </div>

            <div class="stock__form-policy">
              <BaseCheckbox
                v-model="formData.policy"
                class="stock__form-policy-checkbox"
                :errorMsg="errorMessages.policy"
              >
                <span
                  class="simple-link"
                  @click="setPolicyToState"
                >
                  {{ _.get(data, 'policyLabel', '') }}
                  <router-link
                    to="/policy"
                    class="stock__form-policy-link"
                  >
                    {{ _.get(data, 'policyLink', '') }}
                  </router-link>
                </span>
              </BaseCheckbox>
            </div>
          </div>

          <div class="stock__form-submit">
            <BaseButton
              :disabled="!formData.policy"
              @click="submitForm"
            >
              {{ _.get(data, 'submitButtonText', '') }}
            </BaseButton>
          </div>
        </div>
        <div class="stock__auto-panel">
          <div
            v-if="isHasLeftFirstBlock"
            class="stock__auto-info"
          >
            <div class="stock__auto-info-image">
              <img
                :src="_.get(autoPanel, 'image.value', '')"
                class="stock__auto-info-image-img"
                alt=""
              >
            </div>
            <div
              v-if="_.get(autoPanel, 'cashPrice.value', '') || _.get(autoPanel, 'model.value', '')"
              class="stock__auto-info-inner"
            >
              <p
                v-if="_.get(autoPanel, 'brand.value', '') && _.get(autoPanel, 'model.value', '')"
                class="stock__auto-info-item stock__auto-info-item_bold"
              >
                {{ _.get(autoPanel, 'brand.value', '') }} {{ _.get(autoPanel, 'model.value', '') }}
              </p>

              <p
                v-if="_.get(autoPanel, 'cashPrice.value', '')"
                class="stock__auto-info-item stock__auto-info-item_bold"
              >
                {{ _.get(autoPanel, 'cashPrice.value', '') | prettify }} ГРН
              </p>
            </div>

            <div
              v-if="_.get(autoPanel, 'engine.value', '') ||
                _.get(autoPanel, 'fuelType.value', '') ||
                _.get(autoPanel, 'grade.value', '')
              "
              class="stock__auto-info-inner"
            >
              <p
                v-if="_.get(autoPanel, 'engine.value', '')"
                class="stock__auto-info-item"
              >
                <span class="icon icon-engine" /> {{ _.get(autoPanel, 'engine.value', '') }}
              </p>
              <p
                v-if="_.get(autoPanel, 'fuelType.value', '')"
                class="stock__auto-info-item"
              >
                <span class="icon icon-fuel-type" /> {{ _.get(autoPanel, 'fuelType.value', '') }}
              </p>
              <p
                v-if="isShowComplectationText"
                class="stock__auto-info-item stock__auto-info-item_bold"
              >
                {{ complectationText }}
              </p>
              <p
                v-if="_.get(autoPanel, 'grade.value', '')"
                class="stock__auto-info-item"
              >
                <span class="icon icon-insurance" /> {{ _.get(autoPanel, 'grade.value', '') }}
              </p>
            </div>
          </div>
          <div
            v-if="!isHasLeftSecondBlock"
            class="stock__auto-info"
          >
            <div
              v-if="_.get(autoPanel, 'dealerAddress.value', '')"
              ref="map"
              class="stock__auto-info-map"
            />
            <div class="stock__auto-info-inner">
              <p
                v-if="_.get(autoPanel, 'dealerName.value', '')"
                class="stock__auto-info-item stock__auto-info-item_bold"
              >
                {{ _.get(autoPanel, 'dealerName.value', '') }}
              </p>
              <p
                v-if="_.get(autoPanel, 'dealerAddress.value', '')"
                class="stock__auto-info-item"
              >
                {{ _.get(autoPanel, 'dealerAddress.value', '') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import { config } from '../config'

  import appendScripts from '@/mixins/append-head-body-mixin'

  export default {
    name: 'Stock',

    filters: {
      prettify (num) {
        const n = num.toString()
        return n.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, '$1' + ' ')
      }
    },

    mixins: [appendScripts],

    data: () => ({
      data: {},
      formMeta: {},
      autoPanel: {},
      formData: {},
      dataLoaded: false,
      errorMessages: {},
      solution: {},
      hintHeight: 100,
      isHintToggle: false,
      city: '',
      coordinates: {},
      isFetchData: false,

      complectationText: 'Комплектація',

      t1DataLayerModelQuery: {}
    }),

    computed: {
      isShowComplectationText () {
        return this._.get(this.autoPanel, 'grade.value', '')
      },

      isHasLeftFirstBlock () {
        return this._.get(this.autoPanel, 'brand.value', '') ||
          this._.get(this.autoPanel, 'cashPrice.value', '') ||
          this._.get(this.autoPanel, 'model.value', '') ||
          this._.get(this.autoPanel, 'mileage.value', '') ||
          this._.get(this.autoPanel, 'engine.value', '') ||
          this._.get(this.autoPanel, 'fuelType.value', '') ||
          this._.get(this.autoPanel, 'firstRegistrationDate.value', '') ||
          this._.get(this.autoPanel, 'grade.value', '')
      },

      isHasLeftSecondBlock () {
        return this._.isEmpty(this.coordinates)
      }
    },

    watch: {
      dataLoaded () {
        this.$nextTick(() => {
          this.initMap()

          const hint = this.$el.querySelector('.stock__hint')

          if (!this._.isElement(hint)) return false

          if (hint.clientHeight >= this.hintHeight) {
            hint.style.height = this.hintHeight + 'px'
            this.isHintToggle = true
          }
        })
      },

      'autoPanel.dealerName.value' () {
        if (!this.isFetchData) return
        this.pushDataToDataLayer({
          events: {
            eventclass: 'workflowevent',
            eventName: 'workflowevent',
            category: 'component',
            componentname: 'Stock',
            action: 'form-workflow',
            value: 'contact-details',
            workflowname: 'sc-vehicle-request',
            workflowstep: 1,
            workflowconversion: 0
          }
        })
      },

      city () {
        if (!this.isFetchData) return
        this.pushDataToDataLayer({
          events: {
            eventclass: 'workflowevent',
            eventName: 'workflowevent',
            category: 'component',
            componentname: 'Stock',
            action: 'form-workflow',
            value: 'contact-details',
            workflowname: 'sc-vehicle-request',
            workflowstep: 1,
            workflowconversion: 0
          }
        })
      }
    },

    async created () {
      try {
        this.t1DataLayerModelQuery = JSON.parse(this.$route.query.t1DataLayerModel)
      } catch (e) {
        console.warn('t1DataLayerModel object not found on query or has the wrong structure')
      }
      const scripts = {
        body: {
          begin: this.stockScript
        }
      }
      this.appendScriptsToHeadAndBody(scripts)

      const { data } = await this.fetchData()
      window.dataLayer = window.dataLayer || []
      window.t1DataLayer = window.t1DataLayer || {}

      // dataLayer start
      const event = {
        eventclass: 'workflowevent',
        eventName: 'workflowevent',
        category: 'component',
        componentname: 'Stock',
        action: 'form-workflow',
        value: 'contact-details',
        workflowname: 'sc-vehicle-request',
        workflowstep: 1,
        workflowconversion: 0
      }

      const dealer = {
        dealerid: this.checkNull(_.get(data, 'form.dealer_id.value', '')),
        dealername: this.checkNull(_.get(data, 'autoPanel.dealerName.value', '')),
        city: this.checkNull(_.get(_.get(data, 'form.city_id.items', []).find(item => item.value === _.get(data, 'form.city_id.value', '')), 'text', ''))
      }

      const vehicleName = () => {
        if (_.get(data, 'autoPanel.brand.value', '') && _.get(data, 'autoPanel.model.value', '')) {
          return _.get(data, 'autoPanel.brand.value', '') + ' ' + _.get(data, 'autoPanel.model.value', '')
        }
        return ''
      }

      const model = {
        extmodelid: _.get(this.t1DataLayerModelQuery, 'extmodelid') || this.checkNull(_.get(data, 'autoPanel.vehicleForSaleId.value', '')), // vehicleForSaleId
        fueltype: _.get(this.t1DataLayerModelQuery, 'fueltype') || _.get(data, 'autoPanel.fuelType.value', ''), // fuelType
        manufacturerId: _.get(this.t1DataLayerModelQuery, 'manufacturerId') || this.checkNull(_.get(data, 'autoPanel.vin.value', '')), // vin
        manufacturername: _.get(this.t1DataLayerModelQuery, 'manufacturername') || this.checkNull(_.get(data, 'autoPanel.brand.value', '')), // brand
        modelname: _.get(this.t1DataLayerModelQuery, 'modelname') || this.checkNull(_.get(data, 'autoPanel.model.value', '')), // model
        vehiclename: _.get(this.t1DataLayerModelQuery, 'vehiclename') || vehicleName(), // brand + model
        vehicleprice: _.get(this.t1DataLayerModelQuery, 'vehicleprice') || _.get(data, 'autoPanel.cashPrice.value', ''), // cashPrice
        vehicleversion: _.get(this.t1DataLayerModelQuery, 'vehicleversion') || this.checkNull(_.get(data, 'autoPanel.model.value', '')) // model ?
      }

      window.t1DataLayer = { event, dealer, model }
      window.dataLayer.push({
        'event': 'workflowevent'
      })
      // dataLayer end
    },

    methods: {
      pushDataToDataLayer (params = { events: {
        eventclass: 'workflowevent',
        eventName: 'workflowevent',
        category: 'component',
        componentname: 'ThankYouPage',
        action: 'form-workflow',
        value: 'form-submit',
        workflowname: 'sc-vehicle-request',
        workflowstep: 2,
        workflowconversion: 1
      } }, pushDataLayer) {
        // dataLayer start
        const event = params.events

        const dealer = {
          dealerid: this.checkNull(_.get(this.formData, 'dealer_id', '')),
          dealername: this.checkNull(_.get(this.autoPanel, 'dealerName.value', '')),
          city: this.checkNull(this.city)
        }

        const vehicleName = () => {
          if (_.get(this.autoPanel, 'brand.value', '') && _.get(this.autoPanel, 'model.value', '')) {
            return _.get(this.autoPanel, 'brand.value', '') + ' ' + _.get(this.autoPanel, 'model.value', '')
          }
          return ''
        }

        const model = {
          extmodelid: _.get(this.t1DataLayerModelQuery, 'extmodelid') || this.checkNull(_.get(this.autoPanel, 'vehicleForSaleId.value', '')),
          fueltype: _.get(this.t1DataLayerModelQuery, 'fueltype') || _.get(this.autoPanel, 'fuelType.value', ''),
          manufacturerId: _.get(this.t1DataLayerModelQuery, 'manufacturerId') || this.checkNull(_.get(this.autoPanel, 'vin.value', '')),
          manufacturername: _.get(this.t1DataLayerModelQuery, 'manufacturername') || this.checkNull(_.get(this.autoPanel, 'brand.value', '')),
          modelname: _.get(this.t1DataLayerModelQuery, 'modelname') || this.checkNull(_.get(this.autoPanel, 'model.value', '')),
          vehiclename: _.get(this.t1DataLayerModelQuery, 'vehiclename') || vehicleName(),
          vehicleprice: _.get(this.t1DataLayerModelQuery, 'vehicleprice') || _.get(this.autoPanel, 'cashPrice.value', ''),
          vehicleversion: _.get(this.t1DataLayerModelQuery, 'vehicleversion') || this.checkNull(_.get(this.autoPanel, 'model.value', ''))
        }

        window.t1DataLayer = { event, dealer, model }
        if (pushDataLayer) {
          window.dataLayer.push({
            'event': 'workflowevent'
          })
        }
        // dataLayer end
      },

      checkNull (data) {
        if (data) return data
        return ''
      },

      hintToggle (e) {
        if (!this._.isElement(e.currentTarget)) return
        const hint = e.currentTarget.closest('.stock__hint')
        if (!hint.classList.contains('active')) {
          hint.classList.add('active')
          hint.style.height = hint.scrollHeight + 22 + 'px'
        } else {
          hint.classList.remove('active')
          hint.style.height = this.hintHeight + 'px'
        }
      },

      setPolicyToState () {
        this.$store.commit('setStockPolicy', this.stockPolicy)
        localStorage.setItem('stockPolicy', JSON.stringify(this.stockPolicy))
      },

      async submitForm () {
        let params = {}
        if (this.$route.query.dealerId || this.$route.query.dealerName || this.$route.query.dealer) {
          params = {
            iframe: 1
          }
        }

        try {
          const { data } = await window.axios.post(this._.get(this.data, 'formSubmitUrl', ''), this.formData, {
            params
          })

          const response = { ...data, url: this.$route.fullPath }
          this.$destroy()

          this.pushDataToDataLayer(undefined, true)

          this.$router.push({ name: 'thank-you', params: response })
        } catch (err) {
          Object.keys(this.errorMessages).forEach(key => {
            Object.keys(this._.get(err, 'response.data', {})).forEach(keyErrors => {
              if (key === keyErrors) {
                this.errorMessages[key] = this._.get(err, 'response.data', {})[keyErrors]
              }
            })
          })
          console.error('Error post data:', err)
        }
      },

      async getCoordinates (city, dealer) {
        const { data } = await window.axios.get(`/stock/dealer-list?city=${city}&dealerName=${dealer}`)

        this.coordinates = this._.get(data[0], 'coordinates', '')
        if (this._.isArray(data)) {
          data.forEach(el => {
            if (el.value === dealer) {
              this.coordinates = el.coordinates
            }
          })
        }

        this.initMap()
      },

      async getCity (e, item) {
        const { data } = await window.axios.get(`/stock/dealer-list?city=${e}`)
        this.formMeta['dealer_id'].items = data
        this.autoPanel.dealerName.value = null
        if (this.formData && this.formData['dealer_id']) {
          this.formData['dealer_id'] = null
        }
        this.coordinates = {}
        this.city = item.text
        this.initMap()
      },

      async getDealer (e, item) {
        if (this._.get(item, 'value', '')) {
          const { data } = await window.axios({
            method: 'get',
            url: '/stock',
            params: {
              dealerName: this._.get(item, 'text', '')
            }
          })

          this.autoPanel.dealerName.value = this._.get(item, 'text', '')

          if (this.city && data.data.autoPanel.dealerAddress.value) {
            this.autoPanel.dealerAddress.value = this.city + ', ' + data.data.autoPanel.dealerAddress.value
          } else {
            this.autoPanel.dealerAddress.value = this.city
          }

          this.coordinates = item.coordinates
          this.initMap()

          this.stockPolicy = {
            policyText: data.data.policyText,
            formSubmitUrl: this.$route.fullPath,
            closeButtonText: data.data.closeButtonText
          }

          this.stockMarketing = {
            marketingConsentText: data.data.marketingConsentText,
            formSubmitUrl: this.$route.fullPath,
            closeButtonText: data.data.closeButtonText
          }

          this.$store.commit('setStockPolicy', this.stockPolicy)
          this.$store.commit('setStockMarketing', this.stockMarketing)

          this.data.hintText = this._.get(data, 'data.hintText', '')
        }
      },

      async fetchData (url) {
        try {
          const { data } = await window.axios.get(url || this.$route.fullPath)
          this.stockPolicy = {
            policyText: data.data.policyText,
            formSubmitUrl: this.$route.fullPath,
            closeButtonText: data.data.closeButtonText
          }

          this.$store.commit('setStockPolicy', this.stockPolicy)
          this.dataLoaded = true

          this.data = this._.get(data, 'data', {})
          this.formMeta = this._.get(this.data, 'form', {})

          this.autoPanel = this._.get(this.data, 'autoPanel', {})
          this.solution = this._.get(this.data, 'solution', {})

          Object.keys(this._.get(this.solution, 'form', {})).forEach((key) => {
            this.$set(this.formData, key, false)
            this.$set(this.errorMessages, key, '')
          })

          Object.keys(this.formMeta).forEach((key) => {
            if (this._.get(this.formMeta[key], 'value')) {
              this.$set(this.formData, key, this._.get(this.formMeta[key], 'value'))
            } else if (key === 'city_id' && !this._.isEmpty(this._.get(this.autoPanel, 'dealerAddress.value', ''))) {
              this.$set(this.formData, key, this._.get(this.autoPanel, 'dealerAddress.value', ''))
              this.formMeta[key].placeholder = this._.get(this.autoPanel, 'dealerAddress.value', '')
            } else if (key === 'dealer_id' && !this._.isEmpty(this._.get(this.autoPanel, 'dealerName.value', ''))) {
              this.$set(this.formData, key, this._.get(this.autoPanel, 'dealerName.value', ''))
              this.formMeta[key].placeholder = this._.get(this.autoPanel, 'dealerName.value', '')
            } else if (key === 'vin_number' && !this._.isEmpty(this._.get(this.autoPanel, 'vin.value', ''))) {
              this.$set(this.formData, key, this._.get(this.autoPanel, 'vin.value', ''))
            } else {
              this.$set(this.formData, key, '')
            }

            this.$set(this.errorMessages, key, '')
          })

          if (this.formData.city_id && this.formData.dealer_id) {
            this.getCoordinates(this.formData.city_id, this.formData.dealer_id)

            const cityObj = this._.get(this.formMeta, 'city_id.items', []).filter(({ value }) => value === this.formData.city_id)[0]
            this.city = this._.get(cityObj, 'text', '')
            if (this.city && this.autoPanel.dealerAddress.value) {
              this.autoPanel.dealerAddress.value = this.city + ', ' + this.autoPanel.dealerAddress.value
            }
          }

          this.$set(this.formData, 'policy', false)
          this.$set(this.errorMessages, 'policy', '')

          setTimeout(() => {
            this.isFetchData = true
          }, 0)
          return data
        } catch (err) {
          console.error('Error get data:', err)
        }
      },

      async initMap () {
        if (this._.isEmpty(this.coordinates)) return false
        await this.$nextTick()

        const { latitude, longitude } = this.coordinates
        const addressCoordinates = [longitude, latitude]

        if (this._.isEmpty(this.$refs.map)) return
        const map = new window.mapsWrapper.DynamicMap(this.$refs.map, {
          accessToken: config.MAP_KEY,
          center: addressCoordinates,
          marker: addressCoordinates,
          zoom: 13
        })
        if (this._.get(this.autoPanel, 'dealerName.value', '')) {
          map.focusOn({
            dealerName: this._.get(this.autoPanel, 'dealerName.value', ''),
            location: {
              long: longitude,
              lat: latitude
            }
          })
        }
      }
    }
  }
</script>
<style lang="scss">
  .service-request-page__editor-wrapper_stock {
    padding-bottom: 40px;
    margin: 0 15px;
    border-top: 1px solid $c-gray;
  }

  .stock {
    padding-top: 40px;
    padding-bottom: 100px;

    @include mobile {
      padding-bottom: 0;
    }

    &__wrap {
      display: flex;
      flex-wrap: wrap;

      @media only screen and (max-width: 991px) {
        margin: 0 -15px;
      }
    }

    &__auto-panel {
      width: 30%;
      margin-top: 47px;

      @media only screen and (max-width: 991px) {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        margin-top: 0;
        margin-bottom: 48px;
      }

      @include mobile {
        width: 100%;
        margin-bottom: 40px;
      }
    }

    &__auto {
      &-info {
        padding: 25px 15px 25px;
        background-color: $c-gray-extra-light-2;

        &:not(:last-child) {
          margin-bottom: 28px;

          @media only screen and (max-width: 991px) {
            margin-bottom: 0;
          }

          @include mobile {
            margin-bottom: 16px;
          }
        }

        @media only screen and (max-width: 991px) {
          width: calc(50% - 30px);
          margin: 0 15px;
        }

        @include mobile {
          width: calc(100% - 30px);
        }

        &-map {
          height: 250px;
          margin: -25px -15px 25px;
        }

        &-inner {
          &:not(:last-child) {
            padding-bottom: 15px;
            margin-bottom: 15px;
            border-bottom: 1px solid $c-gray;
          }
        }

        &-image {
          margin-bottom: 25px;

          &-img {
            width: 100%;
            max-height: 200px;
            object-fit: contain;
          }
        }

        &-item {
          display: flex;
          color: #595d60;

          &:not(:last-child) {
            margin-bottom: 15px;
          }

          &_bold {
            font-weight: 700;
            color: $c-gray-dark;
          }

          .icon {
            margin-top: 3px;
          }
        }
      }
    }

    &__form {
      width: 70%;
      padding: 15px 15px 15px 0;

      @media only screen and (max-width: 991px) {
        order: 1;
        width: 100%;
        padding: 15px;
      }

      @include mobile {
        width: 100%;
      }

      &-submit {
        @include mobile {
          margin-bottom: 28px;
          text-align: center;
        }
      }

      &-solution {
        width: 100%;
        padding: 0 15px;
        margin-bottom: 28px;

        &-title {
          margin-bottom: 28px;
          font-weight: 600;
        }

        &-description {
          margin-bottom: 28px;
        }

        &-checkbox {
          .checkbox-inner {
            align-items: flex-start;
          }
        }
      }

      &_w100 {
        width: 100%;
        padding: 15px;
      }

      &-fields {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -15px;
      }

      &-input {
        align-items: flex-end;
        width: 50%;
        padding: 0 15px;

        @media only screen and (max-width: 991px) {
          width: 100%;
        }

        .input__error-msg,
        .select__error-msg {
          left: 15px;
        }

        .select__dropdown {
          left: 15px;
          width: calc(100% - 30px);
        }

        &_radio {
          width: 100%;
          padding-bottom: 28px;
        }

        &_area {
          width: 100%;
        }
      }

      &-policy {
        width: 100%;
        padding: 0 15px;

        &-checkbox {
          .checkbox-inner {
            align-items: flex-start;

            .checkbox {
              margin-top: 3px;
            }
          }
        }

        &-text {
          display: inline-block;
          padding-bottom: 28px;
        }

        &-link {
          font-size: 16px;
          color: $c-gray-dark;
        }
      }
    }

    &__hint {
      position: relative;
      overflow: hidden;
      transition: height 0.3s ease;

      &-toggle {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 100%;
        line-height: 22px;
        text-align: right;
        cursor: pointer;
        background: linear-gradient(90deg, hsla(0, 0%, 100%, 0.5), #fff 75%, #fff);
        background-size: 100% 100%;
      }

      &.active {
        .stock__hint-toggle {
          text-align: left;
          transform: rotate(-180deg);
        }
      }
    }

    .input__field,
    .select__field {
      @include mobile {
        font-size: 16px;
      }
    }
  }
</style>
